
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#635BFF","d":"M0 0h32v32H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M14.586 12.11c0-.829.675-1.148 1.794-1.148 1.604 0 3.631.49 5.236 1.36V7.329c-1.753-.702-3.484-.978-5.236-.978-4.286 0-7.136 2.253-7.136 6.015 0 5.867 8.023 4.932 8.023 7.461 0 .978-.845 1.297-2.027 1.297-1.752 0-3.99-.723-5.763-1.7v5.058a14.55 14.55 0 0 0 5.763 1.212c4.391 0 7.41-2.19 7.41-5.995-.021-6.334-8.064-5.207-8.064-7.588"}})])
          )
        }
      }
    